import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _setTimeout from '@babel/runtime-corejs3/core-js-stable/set-timeout';
import _findIndexInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find-index';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import React__default, { useState, useCallback, useRef, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import { useMount, useMountedState } from 'react-use';
import { initPortalRoots, useEventCallback } from '@thimble/utility';
import { c as clsx } from '../clsx.m-7e9a4a81.js';
import Collapse from '../Collapse/index.js';
import { I as Icon } from '../Utilities-be7a8052.js';
import '@babel/runtime-corejs3/helpers/typeof';
import '@babel/runtime-corejs3/core-js-stable/array/is-array';
import '@babel/runtime-corejs3/core-js-stable/object/keys';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import '@babel/runtime-corejs3/core-js-stable/object/define-property';
import '@babel/runtime-corejs3/helpers/extends';
import '@babel/runtime-corejs3/helpers/defineProperty';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';

var isNotificationBoxMounted = false;
var uuid = 0;

var NotificationBox = function NotificationBox() {
  var _context2, _context3;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      notis = _useState2[0],
      setNotis = _useState2[1];

  var push = useCallback(function (v) {
    return setNotis(function (n) {
      var _context;

      return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(n), [v]);
    });
  }, []);
  useMount(function () {
    setNotis(Notification.cache);
    Notification._push = push;
  });
  return /*#__PURE__*/React__default.createElement("div", {
    id: "smbNotificationRoot"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "smb-notification-box-top-left"
  }, _mapInstanceProperty(_context2 = _filterInstanceProperty(notis).call(notis, function (n) {
    var _n$config, _n$config2;

    return !((_n$config = n.config) !== null && _n$config !== void 0 && _n$config.queue) || ((_n$config2 = n.config) === null || _n$config2 === void 0 ? void 0 : _n$config2.queue) === 'top-left';
  })).call(_context2, function (v) {
    return /*#__PURE__*/React__default.createElement(NotificationItem, {
      key: v.id,
      setNotis: setNotis,
      queue: "top-left"
    }, v);
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "smb-notification-box-top-center"
  }, _mapInstanceProperty(_context3 = _filterInstanceProperty(notis).call(notis, function (n) {
    var _n$config3;

    return ((_n$config3 = n.config) === null || _n$config3 === void 0 ? void 0 : _n$config3.queue) === 'top-center';
  })).call(_context3, function (v) {
    return /*#__PURE__*/React__default.createElement(NotificationItem, {
      key: v.id,
      setNotis: setNotis,
      config: v.config,
      queue: "top-center"
    }, v);
  })));
};

var NotificationItem = function NotificationItem(_ref) {
  var _children$config3;

  var children = _ref.children,
      setNotis = _ref.setNotis,
      queue = _ref.queue,
      config = _ref.config;
  var timeout = useRef();

  var _useState3 = useState([true, false]),
      _useState4 = _slicedToArray(_useState3, 2),
      visible = _useState4[0],
      setVisible = _useState4[1];

  useLayoutEffect(function () {
    setVisible([true, true]);
  }, []);
  var mounted = useMountedState();
  var close = useEventCallback(function () {
    // https://stackoverflow.com/questions/53949393/cant-perform-a-react-state-update-on-an-unmounted-component
    if (mounted()) {
      setVisible([false, false]);

      _setTimeout(function () {
        return setNotis(function (v) {
          var index = _findIndexInstanceProperty(v).call(v, function (v) {
            return v === children;
          });

          if (index !== -1) {
            var _context4;

            return _concatInstanceProperty(_context4 = _sliceInstanceProperty(v).call(v, 0, index)).call(_context4, _sliceInstanceProperty(v).call(v, index + 1));
          }

          return v;
        });
      }, 300);
    }
  });
  var startTimeout = useCallback(function () {
    var _children$config;

    if (((_children$config = children.config) === null || _children$config === void 0 ? void 0 : _children$config.timeout) !== 0) {
      var _children$config2;

      timeout.current = _setTimeout(function () {
        close();
      }, ((_children$config2 = children.config) === null || _children$config2 === void 0 ? void 0 : _children$config2.timeout) || 3000);
    }
  }, [(_children$config3 = children.config) === null || _children$config3 === void 0 ? void 0 : _children$config3.timeout, close]);
  useMount(startTimeout);
  var handleMouseEnter = useEventCallback(function () {
    if (timeout.current) clearTimeout(timeout.current);
  });

  if (queue === 'top-center') {
    return /*#__PURE__*/React__default.createElement(Collapse.Panel, {
      className: "smb-notification-item-wrapper",
      classNames: "smb-notification-item-animation",
      active: visible[1],
      onMouseEnter: handleMouseEnter,
      onMouseLeave: startTimeout,
      style: {
        overflow: 'visible'
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: clsx('smb-notification-item', config === null || config === void 0 ? void 0 : config.className)
    }, (config === null || config === void 0 ? void 0 : config.closable) !== false ? /*#__PURE__*/React__default.createElement("div", {
      className: "smb-notification-item__close",
      onClick: close
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "Close",
      size: 20,
      color: "dark-green"
    })) : null, typeof children.content === 'function' ? /*#__PURE__*/React__default.createElement(children.content, {
      close: close
    }) : children.content));
  }

  return /*#__PURE__*/React__default.createElement(CSSTransition, {
    "in": visible[1],
    classNames: "smb-notification-item-animation",
    timeout: 300
  }, /*#__PURE__*/React__default.createElement(Collapse.Panel, {
    className: "smb-notification-item-wrapper",
    active: visible[0],
    onMouseEnter: handleMouseEnter,
    onMouseLeave: startTimeout,
    style: {
      overflow: 'visible'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx('smb-notification-item', config === null || config === void 0 ? void 0 : config.className)
  }, (config === null || config === void 0 ? void 0 : config.closable) !== false ? /*#__PURE__*/React__default.createElement("div", {
    className: "smb-notification-item__close",
    onClick: close
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "Close",
    size: 20,
    color: "dark-green"
  })) : null, typeof children.content === 'function' ? /*#__PURE__*/React__default.createElement(children.content, {
    close: close
  }) : children.content)));
};

var Notification = {
  cache: [],
  _push: function _push(v) {
    this.cache.push(v);
  },
  push: function push(v, config) {
    this.setup();

    this._push({
      id: uuid++,
      content: v,
      config: config
    });
  },
  setup: function setup() {
    var MessageBoxRoot = initPortalRoots('MessageBox');

    if (!isNotificationBoxMounted) {
      isNotificationBoxMounted = true;
      ReactDOM.render( /*#__PURE__*/React__default.createElement(NotificationBox, null), MessageBoxRoot);
    }
  }
};

export default Notification;
